import { render } from "./p-search-table.vue?vue&type=template&id=4894ee7a&scoped=true"
import script from "./p-search-table.vue?vue&type=script&lang=js"
export * from "./p-search-table.vue?vue&type=script&lang=js"

import "./p-search-table.vue?vue&type=style&index=0&id=4894ee7a&scoped=true&lang=scss"
import "./p-search-table.vue?vue&type=style&index=1&id=4894ee7a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4894ee7a"]])

export default __exports__